import React from 'react';
import image from '../images/s_cta_box.png';
import { Link } from 'react-router-dom';
import style from '../css/Shower.module.css';

function Shower() {
	return (
		<div className={style.container}>
			<img src={image} alt="" className={style.image} />
			<div className={style.text_box}>
				<h1 className={style.title}>
					Affordable Home Appliance Repair Services in Bangalore & Dhanbad
				</h1>
				<p className={style.desc}>
					Best Appliance Repair Service in Bangalore & Dhanbad
				</p>
				<Link className={style.btn} to={'/contact-us'}>
					Schedule a repair
				</Link>
			</div>
		</div>
	);
}

export default Shower;
